// extracted by mini-css-extract-plugin
module.exports = {"Instruction":"Instruction_Instruction__6lEM4","Step":"Instruction_Step__3qzIo","Image":"Instruction_Image__27pFy","SupportEmail":"Instruction_SupportEmail__2XK-e"};